import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { TooltipModule } from 'ng2-tooltip-directive';
import { NgxSpinnerModule } from 'ngx-spinner';

import {
  ToolbarModule,
  TabsModule,
  FilterModule,
  DetailsModule,
  PaginationModule,
  OrdersModule,
  SettingsModule,
  TableModule,
  DaterangepickerModule,
  SharedModule,
} from 'beyond-util';

import { EmisijeComponent } from './emisije.component';
import { EmisijaCenaDetailsComponent } from '../../../components/emisija-cena-details/emisija-cena-details.component';

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
    FilterModule,
    DetailsModule,
    PaginationModule,
    OrdersModule,
    SettingsModule,
    ToolbarModule,
    TableModule,
    DaterangepickerModule,
    SharedModule,
    TooltipModule,
    NgxSpinnerModule,
  ],
  declarations: [EmisijeComponent, EmisijaCenaDetailsComponent],
  entryComponents: [EmisijeComponent, EmisijaCenaDetailsComponent],
  exports: [EmisijeComponent],
})
export class EmisijeModule {}



// WEBPACK FOOTER //
// ./src/app/pages/sifarnici/emisije/emisije.module.ts